import tw, { styled } from 'twin.macro'

export const StyledCardGrid = styled.div(() => [tw`grid gap-6 sm:grid-cols-2 md:grid-cols-3`])
